export default __webpack_public_path__ + "static/media/2353.a30b9432.png";